import getDPR from './getDPR'

export default function roundByDPR(element: Element, value: number) {
  const dpr = getDPR(element)
  return Math.round(value * dpr) / dpr
}
